
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hjalp-vid-illabehandling",
      function () {
        return require("private-next-pages/hjalp-vid-illabehandling.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hjalp-vid-illabehandling"])
      });
    }
  